module.exports = __webpack_public_path__ + "static/CircularStd-BookItalic-43c21b2d5feda3fdc916933a4b66682a.ttf";